import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { resolveReturnPathForLogin } from '../../utils/authSessionExpired';
import LoadingOverlay from '../common/LoadingOverlay';

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingOverlay />;
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: resolveReturnPathForLogin(location),
        }}
      />
    );
  }

  return children;
}
